import { render, staticRenderFns } from "./DetalheTituloReapresentacao.vue?vue&type=template&id=b1ce527a&scoped=true"
import script from "./DetalheTituloReapresentacao.vue?vue&type=script&lang=js"
export * from "./DetalheTituloReapresentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ce527a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1ce527a')) {
      api.createRecord('b1ce527a', component.options)
    } else {
      api.reload('b1ce527a', component.options)
    }
    module.hot.accept("./DetalheTituloReapresentacao.vue?vue&type=template&id=b1ce527a&scoped=true", function () {
      api.rerender('b1ce527a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/DetalheTituloReapresentacao.vue"
export default component.exports